import { atom } from 'recoil';

const loading = atom<boolean>({
  key: 'stripe-loading',
  default: false,
});

export const StripeAtoms = { loading };
